import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import profilesData from '../data/profiles.json';

interface Profile {
  id: string;
  type: string;
  title: string;
  shortDescription: string;
  longDescription: string;
  image: string;
  youtubeVideoId?: string;
  gumroadLink: string;
}

const ProfileDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [profile, setProfile] = useState<Profile | null>(null);

  useEffect(() => {
    const foundProfile = profilesData.find((p) => p.id === id);
    setProfile(foundProfile || null);
  }, [id]);

  if (!profile) {
    return <div className="text-white p-4">Profile not found.</div>;
  }

  return (
    <div className="container mx-auto mt-8 p-4">
      <div className="bg-gray-700 rounded-lg shadow-lg p-6">
        <h2 className="text-3xl font-bold text-white mb-4">{profile.title}</h2>
        <img
          src={profile.image}
          alt={profile.title}
          className="w-full h-auto rounded-lg mb-4"
        />
        <p className="text-gray-300 mb-4">{profile.longDescription}</p>
        {profile.youtubeVideoId && (
          <div className="aspect-w-16 aspect-h-9 mb-4">
            <iframe
              width="560"
              height="315"
              src={`https://www.youtube.com/embed/${profile.youtubeVideoId}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}
        <a
          href={profile.gumroadLink}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-4 inline-block"
        >
          Buy on Gumroad
        </a>
      </div>
    </div>
  );
};

export default ProfileDetails;